// extracted by mini-css-extract-plugin
export default {"switchRow":"LeadFields_switchRow__sgwkB","switchLabel":"LeadFields_switchLabel__hc0Gi"};